/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */

import { ConeGeometry, TorusGeometry, SphereGeometry, MeshToonMaterial, MeshPhongMaterial, Mesh, FlatShading, Group, DoubleSide } from 'three'


class Ridge { //creates individual ridges of clam
  constructor(radius, height, thetaStart, theta, ridgeMaterial) {
    this.ridgeGeometry = new ConeGeometry( radius, height, 6, 1, true, thetaStart, theta )
    this.ridgeMaterial = new MeshPhongMaterial({color: 0xd2e8ff, emissive: 0x444444})
    this.ridgeMaterial.side = DoubleSide
    this.ridgeMesh = new Mesh( this.ridgeGeometry, this.ridgeMaterial)
  }
}

 class Clam { // class for entire Clam
   constructor(color) {
     this.group = new Group()
     this.materials = []

     this.tongueGeometry = new TorusGeometry( .7, .9, 10, 16 ) // tongue of clam
     this.tongueMaterial = new MeshToonMaterial( {color: 0x9D655B, shading: FlatShading})
     this.materials.push(this.tongueMaterial)
     this.tongueMesh = new Mesh(this.tongueGeometry, this.tongueMaterial)
     this.tongueMesh.rotation.y = 1.6
     this.tongueMesh.position.y = -1.4
     this.tongueMesh.position.x = -.83


     this.pearl = new SphereGeometry( .4, 7, 7 ); // pearl of clam
     this.pearlMaterial = new MeshPhongMaterial( {color: 0xfbfdff, emissive: 0xd2e8ff})
     this.materials.push(this.pearlMaterial)
     this.pearlMesh = new Mesh(this.pearl, this.pearlMaterial)
     this.pearlMesh.position.y = -1.75


     this.clamTop = new Group() // top shell of clam
     this.clamBottom = new Group() // bottom shell of clam

     this.materials = makeClam(3, .5, .31, .04, 0, 3, this.clamTop, this.materials)
     this.materials = makeClam(3, .5, -.31, .04, 0, 3, this.clamTop, this.materials)
     this.materials = makeClam(3, .5, .27, 0, .5, 2, this.clamBottom, this.materials)
     this.materials = makeClam(3, .5, -.27, 0, .5, 2, this.clamBottom, this.materials)

     this.clamTop.rotation.z = .3
     this.clamBottom.rotation.y = 3.15

     // function to make ridges using Ridge class
     function makeClam(height, radius, rotateIncrement, curveIncrement, thetaStart, theta, group, materials) {
       var rotate = 0
       var curve = 0
       for( let i = 0; i < 12; i++ ) {
         const newRidge = new Ridge(radius, height, thetaStart, theta)
         materials.push(newRidge.ridgeMaterial)
         newRidge.ridgeGeometry.translate(0, -height/2, 0)
         newRidge.ridgeMesh.rotation.x = rotate
         newRidge.ridgeMesh.rotation.z = curve
         group.add(newRidge.ridgeMesh)
         rotate += rotateIncrement - (rotate * .22)
         if (i < 3 ) {
           height -= height * .02
         } else {
           height -= height * .07
         }
         radius -= .03
         curve -= curveIncrement
       }
       return materials
     }

     this.group.add(this.clamTop, this.clamBottom, this.tongueMesh, this.pearlMesh)
     this.group.scale.set(.2,.2,.2)

   }
 }


export default Clam
